module.exports = __webpack_public_path__ + "img/B高通100.933b83cd.png";